var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "f7-list",
        { attrs: { "media-list": "" } },
        _vm._l(_vm.remindSettings, function (remindSetting) {
          return _c(
            "li",
            {
              staticClass: "item-content",
              on: {
                click: function ($event) {
                  return _vm.editRemindSetting(remindSetting)
                },
              },
            },
            [
              _c("div", { staticClass: "item-media" }, [
                _c("i", { staticClass: "icon list-icon icon-alarmclock" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-inner" }, [
                _c("div", { staticClass: "item-title-row" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(remindSetting.label)),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }